__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/4dc95e3/_next/";